<section class="content">
  <h1 class="title">Admin Dashboard</h1>
  <div class="tiles-area">
    <div class="tile"
         routerLink="/admin/notifications-management">
      <div class="img-box">
        <div class="d-flex jcc tile-icon icon-hageda">&nbsp;</div>
      </div>
      <h3 class="text-center">Portal&shy;benachrichtigungen ></h3>
    </div>
    <div class="tile"
         routerLink="/admin/user-management">
      <div class="img-box">
        <div class="d-flex jcc tile-icon icon-hageda">&nbsp;</div>
      </div>
      <h3 class="text-center">Benutzer ></h3>
    </div>
    <div class="tile"
         routerLink="/admin/internal-management">
      <div class="img-box">
        <div class="d-flex jcc tile-icon icon-hageda">&nbsp;</div>
      </div>
      <h3 class="text-center">Mitarbeitern ></h3>
    </div>
    <div class="tile"
         routerLink="/admin/cms-management">
      <div class="img-box">
        <div class="d-flex jcc tile-icon icon-hageda">&nbsp;</div>
      </div>
      <h3 class="text-center">CMS Management ></h3>
    </div>
    <div class="tile"
         routerLink="/admin/slider-management">
      <div class="img-box">
        <div class="d-flex jcc tile-icon icon-hageda">&nbsp;</div>
      </div>
      <h3 class="text-center">Karussellverwaltung ></h3>
    </div>
    <div class="tile"
         routerLink="/admin/preorders-management">
      <div class="img-box">
        <div class="d-flex jcc tile-icon icon-hageda">&nbsp;</div>
      </div>
      <h3 class="text-center">Vorbestellung ></h3>
    </div>
  </div>
</section>
